export default {"src":"/_next/static/media/messageStar.c22e2572.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};